import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/organisms/regulation/regulation-list/regulation-list.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/templates/site-layout/site-layout.tsx")